import { Controller } from "@hotwired/stimulus"
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import Modal from '../../../frontend/components/Modal.vue'
import MorePopover from '../../../frontend/components/MorePopover.vue'
import CalendarPopover from '../../../frontend/components/CalendarPopover.vue'
import PrimeVue from 'primevue/config'

export default class extends Controller {
  connect() {
    this.modalApp = createApp(Modal)
    this.modalApp.use(PrimeVue, { unstyled: true })
    this.modalApp.component('morepopover', MorePopover)
    this.modalApp.component('calendarpopover', CalendarPopover)

    const app = this.modalApp.mount('#modal-box')

    this.open_url = app.open_url
  }

  open(event) {
    event.preventDefault()
    this.open_url(event.currentTarget.href, event.currentTarget.dataset)
  }

  disconnect() {
    if (this.modalApp) {
      this.modalApp.unmount()
    }
  }
}
